angular.module('ikeweb.unit').service('unitService', ['loginService', 'ikemath',

    function(loginService, ikemath) {

        var Units = ikemath.Units;

        function getUnitList() {
            return Units.LIST;
        }

        function getDefaultUnit() {
            return Units.FEET;
        }

        function getUnit() {
            var user = loginService.getLoggedInUser();
            return user && user.getUnit() || getDefaultUnit();
        }

        function setUnit(unit) {
            return loginService.save(loginService.getLoggedInUser().setUnit(unit));
        }

        return {
            getUnit: getUnit,
            setUnit: setUnit,
            getUnitList: getUnitList
        };
    }
]).config(['$provide',
    function($provide) {

        $provide.decorator('unitService', ['$delegate', 'decoratedPromiseBuilder', 'notificationService', '$translate', 'functional',
            function($delegate, decoratedPromiseBuilder, notificationService, $translate, f) {

                var getUnitList = $delegate.getUnitList;
                $delegate.getUnitList = function() {
                    return getUnitList().map(function(unit) {
                        var clonedUnit = f.cloneMap(unit);
                        clonedUnit.label = $translate.instant('COMPONENT.UNIT.' + unit.value.toUpperCase());
                        return clonedUnit;
                    });
                };

                return decoratedPromiseBuilder
                    .forDelegate($delegate)
                    .decorate('setUnit')
                    .onSuccess(notificationService.success('NOTIFICATION.UNIT.CHANGE_PREFERENCES', 'NOTIFICATION.UNIT.PREFERENCES_CHANGED'))
                    .onError(notificationService.error('NOTIFICATION.UNIT.CHANGE_PREFERENCES', 'NOTIFICATION.UNIT.CHANGE_PREFERENCES_PROBLEM'))
                    .fork();
            }
        ]);
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/unit/unit.service.js
// module id = 444
// module chunks = 0